var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 21",
    enableBackground: "new 0 0 32 21",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262626",
    points: "0.06,13.1 0.05,12.75 2.27,12.31 2.26,12.91 0.35,13.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262626",
    points: "0,9.89 8.94,8.53 8.66,13.16 0.31,10.47 0.29,9.98  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262626",
    d: "M4.03,10.63L4.03,10.63l-0.15,0.03L2,11.01l0.58,4.22l2.13-0.39 l0,0c0.03-0.01,0.05-0.01,0.07-0.02c0.6-0.16,0.92-1.23,0.72-2.38C5.28,11.28,4.63,10.48,4.03,10.63L4.03,10.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262626",
    d: "M7.37,15.78c0.01-0.01,0.03-0.01,0.04-0.01 c0.64-0.16,0.99-1.26,0.77-2.44c-0.22-1.15-0.88-1.96-1.51-1.86l0,0H6.66c-0.01,0-0.02,0.01-0.03,0.01l-1.98,0.38l0.59,4.33 L7.37,15.78L7.37,15.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515151",
    d: "M0.35,13.19L0.06,13.1L0,9.89l0.29,0.09l0.01,0.49l1.58,0.51 l0.52,2.54l-1.5-0.46l-0.56-0.17L0.35,13.19z M8.13,14.89c0.13-0.44,0.15-0.98,0.05-1.56c-0.02-0.12-0.05-0.24-0.08-0.35l9.22,2.96 l-0.36,2.46l-3.84-1.29l-0.01-0.39L8.13,14.89L8.13,14.89z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262626",
    points: "1.25,12.25 1.75,11.22 2.01,11.13 2,11.01 2.73,10.88  2.73,10.88 2.53,10.8 1.94,10.71 1.56,10.88 1.49,10.9 1.06,11.56 0.89,12.61 0.88,13.06 0.88,13.29 1.05,13.37 1.26,13.33  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3F3F3F",
    d: "M4.53,11.87c-0.64,0.16-0.99,1.26-0.77,2.44 c0.22,1.19,0.93,2.02,1.57,1.85C5.97,16,6.32,14.9,6.1,13.72C5.88,12.54,5.17,11.7,4.53,11.87L4.53,11.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#CCCCCC",
    d: "M4.7,12.66c0.02-0.01,0.04-0.01,0.05-0.01 c0.17,0,0.34,0.17,0.43,0.29c0.19,0.25,0.32,0.59,0.37,0.9c0.06,0.35,0.07,0.74-0.04,1.08c-0.05,0.16-0.16,0.41-0.35,0.45 c-0.02,0.01-0.04,0.01-0.05,0.01c-0.17,0.01-0.34-0.16-0.43-0.28c-0.19-0.26-0.32-0.59-0.37-0.91c-0.06-0.34-0.07-0.74,0.04-1.08 C4.4,12.95,4.51,12.7,4.7,12.66L4.7,12.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3F3F3F",
    d: "M1.92,11.03c-0.6,0.16-0.92,1.23-0.72,2.38 c0.21,1.16,0.86,1.97,1.46,1.81c0.6-0.16,0.92-1.22,0.71-2.38C3.17,11.68,2.52,10.87,1.92,11.03L1.92,11.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#CCCCCC",
    d: "M2.1,11.96c0.02-0.01,0.03-0.01,0.04-0.01 c0.13,0,0.26,0.15,0.33,0.24c0.16,0.22,0.26,0.51,0.31,0.78c0.05,0.3,0.06,0.64-0.03,0.94c-0.04,0.13-0.13,0.34-0.27,0.38 c-0.02,0-0.03,0.01-0.04,0.01c-0.13,0-0.26-0.15-0.34-0.24c-0.16-0.22-0.26-0.52-0.31-0.78c-0.05-0.29-0.05-0.64,0.03-0.93 C1.86,12.21,1.96,11.99,2.1,11.96L2.1,11.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D1302D",
    d: "M8.49,13.37c-0.28-1.39-0.73-2.02-1.31-2.22l-2.6-0.84 c-0.24-0.08-0.45-0.1-0.65-0.06L1.98,10.6v0.01c-0.24,0.02-0.46,0.12-0.66,0.34c-0.52,0.54-0.53,1.64-0.44,2.35l0.17,0.07 C1,12.97,0.96,12.49,1.04,12.02c0.08-0.45,0.24-0.76,0.43-0.97c0.25-0.26,0.57-0.33,0.89-0.22L5,11.69 c0.58,0.19,0.99,0.8,1.27,2.19l2.04-0.34l0.15-0.15C8.48,13.37,8.49,13.37,8.49,13.37z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515151",
    points: "0.31,10.47 0.29,9.98 7.16,8.93 7.16,9.38  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B61C17",
    d: "M31.23,14.84c-0.19-0.6-0.59-1.11-1.09-1.39l0.02-1.03l-1.01-0.32 l-0.05,3.13l0.47-0.11l0,0.05L31.23,14.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262626",
    d: "M16.46,18.64l0.21,0.07l0.95-0.22l0.11-0.25 c0.01-0.02,0.01-0.03,0.01-0.04l0.48-0.39c0.02-0.03,0.03-0.03,0.04-0.06l1.21-1.77l-0.48-0.32l-0.03-0.03l-0.92-0.09l-0.82,0.33 l-0.03,0.01l-0.55,0.93c-0.01,0.03-0.01,0.04-0.01,0.07l-0.11,1.04l0.03,0.12L16.46,18.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#999999",
    d: "M19.22,2.63l-0.01-2.38L18.02,0c-0.36,0.05-0.34,0.54-0.14,0.66 l0.66,0.16l0.01,1.68L19.22,2.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262626",
    d: "M19.73,15.63c-0.02,0.01-0.03,0.01-0.05,0.01l-1.71,0.38 l1.06,4.93l1.76-0.39l0,0c0.01,0,0.01,0,0.01,0c0.86-0.19,1.33-1.44,1.03-2.81c-0.29-1.34-1.21-2.28-2.06-2.13l0,0l0,0 C19.76,15.62,19.75,15.62,19.73,15.63L19.73,15.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262626",
    d: "M17.17,15.9l-0.54,0.91c-0.01,0.03-0.01,0.04-0.01,0.07 l-0.11,1.04l0.03,0.12l-0.03,0.23l0.44,0.15l0.36-2.46L17.17,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D1302D",
    d: "M23.31,16.53l-2.14,0.46l-1.24-0.68 c-0.58-0.92-2.38-1.13-2.95-0.05l-8.42-2.77v-0.51L7.7,12.69L7.66,4.38l6.32,1.45l9.77-0.72l0.87,3.8l0.04,0.04l4.82,2.39 l-0.02,3.91L23.31,16.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B61C17",
    d: "M20.42,16.59l-0.49-0.27c-0.58-0.92-2.38-1.13-2.95-0.05 l-8.42-2.77l-0.86-0.8L7.67,4.38l6.31,1.45l9.77-0.72l0.87,3.8l-4.08,0.77l-5.57,0.83l5.43,2.66L20.42,16.59z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#474747",
    points: "11.03,9.37 13.87,10.2 13.19,6.69 11.03,6.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#424242",
    points: "19.87,6.19 23.66,5.48 24.4,8.72 20.64,9.45  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D1302D",
    d: "M13.14,5.64L7.66,4.38l10.25-1.06l5.36,1.14 c0.3,0.1,0.35,0.16,0.73,0.61c0.12,0.16,0.06,0.33-0.07,0.36l-4.22,0.79l-5.36,0.57c0.11-0.17,0.04-0.39-0.23-0.68 C13.85,5.81,13.55,5.73,13.14,5.64L13.14,5.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B61C17",
    d: "M13.14,5.64L7.66,4.38l10.25-1.06l5.36,1.14 c0.13,0.04,0.21,0.07,0.29,0.14l-4.19,0.75l-5.45,0.59C13.71,5.77,13.46,5.71,13.14,5.64L13.14,5.64z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#424242",
    points: "19.47,6.24 14.37,6.79 15.11,10.22 20.26,9.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B61C17",
    points: "20.4,13.18 20.42,16.59 21.04,16.93 22.98,16.49  23.04,12.56 22.44,13.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B61C17",
    points: "16.79,10.25 22.44,13.08 23.02,12.58 17.06,10.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D1302D",
    points: "13.87,10.2 11.03,9.37 11.03,12.64 13.18,13.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D4D4D4",
    points: "22.18,13.49 20.66,13.56 20.67,15.98 22.19,15.94  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#CCCCCC",
    d: "M22.4,4.26l-9.81,1.25L7.66,4.37V3.09l9.92-1.13l2.83,0.51 C21.6,2.7,22.1,3.23,22.4,4.26L22.4,4.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#999999",
    d: "M10.12,3.49L7.66,3.09v1.29l4.93,1.14 C12.33,4.37,11.68,3.8,10.12,3.49L10.12,3.49z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D4D4D4",
    points: "19.48,14.24 19.48,14.99 18.8,14.74 18.79,13.98  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3F3F3F",
    d: "M17.88,16.04c-0.87,0.19-1.33,1.45-1.03,2.81 c0.29,1.36,1.24,2.32,2.1,2.13c0.86-0.18,1.33-1.44,1.03-2.81C19.68,16.8,18.74,15.85,17.88,16.04L17.88,16.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#CCCCCC",
    d: "M18.08,17c0.03-0.01,0.06-0.01,0.09-0.01 c0.24-0.01,0.47,0.17,0.62,0.34c0.24,0.27,0.4,0.64,0.47,0.99c0.08,0.35,0.08,0.75-0.02,1.1c-0.07,0.22-0.21,0.47-0.43,0.56 c-0.03,0.01-0.06,0.02-0.09,0.03c-0.03,0.01-0.06,0.01-0.09,0.01c-0.24,0-0.46-0.17-0.62-0.34c-0.24-0.27-0.39-0.63-0.47-0.98 c-0.07-0.35-0.08-0.75,0.03-1.1c0.07-0.22,0.2-0.47,0.42-0.57C18.02,17.02,18.06,17.01,18.08,17L18.08,17z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D1302D",
    d: "M19.78,15.47c-0.37-0.23-0.75-0.28-1.09-0.19l-0.83,0.18 c0.02,0,0.05,0,0.07,0c-0.39,0.04-0.74,0.26-1.03,0.63c-0.45,0.61-0.51,1.43-0.47,2.17c0.01,0.12,0.01,0.24,0.03,0.37l0.21,0.07 c-0.02-0.18-0.04-0.35-0.04-0.51c-0.03-0.65,0.02-1.38,0.42-1.92c0.43-0.57,1.07-0.75,1.7-0.36c0.64,0.41,1.15,1.25,1.41,2.52 l0.95-0.22l0.2-0.21C20.99,16.75,20.45,15.89,19.78,15.47z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#474747",
    points: "20.78,16.89 20.74,20 21.45,20.22 31.22,17.6 32,14.86  31.29,14.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515151",
    points: "21.49,17.12 21.45,20.22 31.93,17.82 32,14.86  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#CCCACA",
    points: "23.27,12.18 29.55,11.01 30.06,11.17 29.92,15.2  23.6,16.52 23.21,16.3  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515151",
    d: "M13.09,14.31l-4.53-1.34c-1.06,0.08-1.42,1.79-0.24,2.27 l4.78,1.72v-0.24L13.09,14.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#AAAAAA",
    d: "M8.02,13.19c-0.22,0.18-0.37,0.46-0.42,0.75l4.75,1.63 c0.02-0.34,0.13-0.67,0.34-0.91L8.02,13.19z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515151",
    d: "M28.91,12.16c0-0.08,0.08-0.16,0.18-0.17 c0.09-0.02,0.17,0.03,0.17,0.11c-0.01,0.43-0.03,0.86-0.04,1.29c-0.01,0.43-0.03,0.86-0.04,1.29c0,0.08-0.08,0.16-0.18,0.18 c-0.09,0.02-0.17-0.04-0.17-0.11c0.01-0.43,0.03-0.86,0.04-1.29C28.88,13.02,28.9,12.59,28.91,12.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515151",
    d: "M28.17,12.29c0-0.08,0.08-0.16,0.18-0.18 c0.09-0.02,0.17,0.04,0.17,0.11c-0.01,0.43-0.03,0.86-0.04,1.29c-0.01,0.43-0.02,0.86-0.04,1.29c0,0.08-0.08,0.16-0.18,0.18 c-0.09,0.02-0.17-0.03-0.16-0.11c0.01-0.43,0.02-0.86,0.04-1.29C28.14,13.15,28.15,12.72,28.17,12.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515151",
    d: "M27.42,12.42c0-0.08,0.08-0.16,0.18-0.18 c0.09-0.02,0.17,0.04,0.17,0.11c-0.01,0.44-0.03,0.87-0.04,1.3c-0.01,0.43-0.02,0.86-0.04,1.29c0,0.08-0.08,0.16-0.17,0.18 c-0.09,0.02-0.17-0.03-0.17-0.11c0.01-0.43,0.02-0.86,0.03-1.29C27.4,13.28,27.41,12.85,27.42,12.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515151",
    d: "M26.68,12.55c0-0.08,0.08-0.16,0.17-0.18 c0.1-0.02,0.17,0.04,0.17,0.12c-0.01,0.43-0.02,0.87-0.04,1.3c-0.01,0.43-0.02,0.87-0.03,1.3c0,0.08-0.08,0.16-0.17,0.18 c-0.09,0.02-0.17-0.03-0.17-0.11c0.01-0.44,0.02-0.87,0.03-1.3C26.65,13.42,26.66,12.99,26.68,12.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515151",
    d: "M25.93,12.68c0-0.08,0.08-0.16,0.18-0.18 c0.09-0.02,0.17,0.04,0.17,0.12c-0.01,0.44-0.02,0.87-0.03,1.3c-0.01,0.44-0.02,0.87-0.03,1.31c0,0.08-0.08,0.16-0.18,0.18 c-0.09,0.02-0.17-0.03-0.17-0.11c0.01-0.44,0.02-0.87,0.03-1.31C25.91,13.55,25.92,13.12,25.93,12.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515151",
    d: "M25.18,12.81c0-0.08,0.08-0.16,0.18-0.18 c0.09-0.01,0.17,0.04,0.17,0.12c-0.01,0.44-0.02,0.87-0.03,1.31c0,0.44-0.01,0.87-0.02,1.31c0,0.08-0.08,0.16-0.17,0.18 c-0.1,0.02-0.17-0.04-0.17-0.12c0.01-0.44,0.02-0.87,0.03-1.31C25.17,13.69,25.17,13.25,25.18,12.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515151",
    d: "M24.41,14.26c0.01-0.44,0.01-0.88,0.02-1.32 c0-0.08,0.08-0.16,0.17-0.18c0.1-0.01,0.17,0.04,0.17,0.12c-0.01,0.44-0.01,0.88-0.02,1.32c-0.01,0.44-0.02,0.88-0.02,1.31 c0,0.08-0.08,0.16-0.17,0.18c-0.09,0.02-0.17-0.03-0.17-0.11C24.4,15.14,24.41,14.7,24.41,14.26z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#999999",
    d: "M8.8,12.69c0.15-0.1,0.14-0.62-0.13-0.68l-0.43,0.08L8.22,1.4 L6.83,1.17C6.46,1.22,6.49,1.71,6.7,1.84l0.81,0.13L7.6,12.59c0,0.08,0.03,0.15,0.09,0.19c0.06,0.05,0.13,0.07,0.21,0.06L8.8,12.69 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#CCCCCC",
    d: "M8.59,5.53c0-0.05-0.15-0.08-0.36-0.11v0.11v0.01 c0,0.04-0.15,0.06-0.34,0.06c-0.19,0-0.35-0.04-0.35-0.06V5.53c0,0,0,0,0-0.01V5.42c-0.24,0.02-0.4,0.06-0.4,0.11l0.04,5 c0,0.07,0.33,0.13,0.73,0.13c0.4,0,0.73-0.06,0.73-0.13L8.59,5.53z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.a73f7711bd46a365b05cd6079d74f042.svg";
export { ForwardRef as ReactComponent };